import "./styles.scss";
import React, { useState } from "react";
import logo from "assets/images/logo.png";
import {
	Collapse,
	Container,
	DropdownMenu,
	DropdownToggle,
	Nav,
	Navbar,
	NavbarToggler,
	NavItem,
	UncontrolledDropdown,
	DropdownItem,
} from "reactstrap";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Link, withRouter, useLocation } from "react-router-dom";
import "assets/scss/website/app.scss";
import { withTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { logout, logoutStore } from "store/Auth/actions";
import AuthService, { logoutFn } from "services/Website/AuthService";
import { useTranslation } from "react-i18next";
import LangSwitcher from "components/LangSwitcher";

const Header = (props) => {
	const { t } = useTranslation();
	const AuthData = useSelector((state) => state.Auth);
	const [isOpenMenu, setisOpenMenu] = useState(false);
	const { pathname } = useLocation();
	const dispatch = useDispatch();

	const Logout = () => {
		AuthService.logout();
		dispatch(logoutStore());
		logoutFn().catch(() => {});
	};

	return (
		<nav className="site-navbar" aria-label="Main navigation">
			<Container>
				<Navbar expand="lg" className="p-0">
					<Link
						to="/"
						className="navbar-brand-logo"
						aria-label="VR Premium Studio — home">
						<img
							src={logo}
							height={64}
							width={64}
							alt="VR Premium Studio"
							className="img-fluid p-0"
						/>
					</Link>

					<div className="two">
						<Collapse navbar>
							<div className="header-collapse w-100">
								<Nav navbar className="d-flex align-items-center">
									<div className="nav-links">
										<NavItem>
											<Link
												to="/"
												style={{ fontWeight: pathname === "/" ? 600 : 400 }}>
												{t("Home")}
											</Link>
										</NavItem>
										<NavItem>
											<Link
												to="/games"
												style={{
													fontWeight: pathname === "/games" ? 600 : 400,
												}}>
												{t("games")}
											</Link>
										</NavItem>
										<NavItem>
											<Link
												to="/about-us"
												style={{
													fontWeight: pathname === "/about-us" ? 600 : 400,
												}}>
												{t("About Us")}
											</Link>
										</NavItem>
										<NavItem>
											<Link
												to="/support"
												style={{
													fontWeight: pathname === "/support" ? 600 : 400,
												}}>
												{t("support")}
											</Link>
										</NavItem>
									</div>
								</Nav>
							</div>
						</Collapse>
					</div>

					<div className="three">
						<LangSwitcher />
						{AuthData?.accessToken && AuthData.userType === "user" && (
							<div className="wallet-details">
								<svg
									width="16"
									height="16"
									viewBox="0 0 16 16"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M12.6667 4.66667V2.66667C12.6667 2.48986 12.5964 2.32029 12.4714 2.19526C12.3464 2.07024 12.1768 2 12 2H3.33333C2.97971 2 2.64057 2.14048 2.39052 2.39052C2.14048 2.64057 2 2.97971 2 3.33333C2 3.68696 2.14048 4.02609 2.39052 4.27614C2.64057 4.52619 2.97971 4.66667 3.33333 4.66667H13.3333C13.5101 4.66667 13.6797 4.7369 13.8047 4.86193C13.9298 4.98695 14 5.15652 14 5.33333V8M14 8H12C11.6464 8 11.3072 8.14048 11.0572 8.39052C10.8071 8.64057 10.6667 8.97971 10.6667 9.33333C10.6667 9.68696 10.8071 10.0261 11.0572 10.2761C11.3072 10.5262 11.6464 10.6667 12 10.6667H14C14.1768 10.6667 14.3464 10.5964 14.4714 10.4714C14.5964 10.3464 14.6667 10.1768 14.6667 10V8.66667C14.6667 8.48986 14.5964 8.32029 14.4714 8.19526C14.3464 8.07024 14.1768 8 14 8Z"
										stroke="#00D1FF"
										strokeWidth="1.33333"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
									<path
										d="M2 3.33325V12.6666C2 13.0202 2.14048 13.3593 2.39052 13.6094C2.64057 13.8594 2.97971 13.9999 3.33333 13.9999H13.3333C13.5101 13.9999 13.6797 13.9297 13.8047 13.8047C13.9298 13.6796 14 13.5101 14 13.3333V10.6666"
										stroke="#00D1FF"
										strokeWidth="1.33333"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
								</svg>
								<span className="wallet-amount">
									{AuthData?.wallet_total_amount?.toFixed(3) || 0} KWD
								</span>
							</div>
						)}

						{AuthData?.accessToken && AuthData.userType === "user" ? (
							<UncontrolledDropdown
								className="d-flex align-items-center fw-bold"
								inNavbar
								nav>
								<DropdownToggle caret nav>
									<span className="text-primary bask-font font-size-22">
										{!!AuthData.avatar ? (
											<img
												className="rounded-circle header-profile-user p-0"
												src={AuthData.avatar}
												width={34}
												height={34}
												alt="Header Avatar"
											/>
										) : AuthData.full_name ? (
											<i className="fa fa-user font-size-18" /> ||
											AuthData.full_name
										) : (
											"U"
										)}
										<i
											className="fa fa-chevron-down fa-lg font-size-14"
											style={{ marginLeft: "10px" }}></i>
									</span>
								</DropdownToggle>
								<DropdownMenu right className="profile-dropdown">
									<div className="profile-info">
										<p className="name">{AuthData?.full_name}</p>
										<p className="email">{AuthData?.email}</p>
									</div>
									<DropdownItem
										onClick={() => props.history.push("/my-bookings")}>
										{/* <Link to="/"> */}
										<svg
											width="16"
											height="16"
											viewBox="0 0 16 16"
											fill="none"
											xmlns="http://www.w3.org/2000/svg">
											<path
												d="M5.33398 1.33325V3.99992"
												stroke="#D1D5DC"
												strokeWidth="1.33333"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
											<path
												d="M10.666 1.33325V3.99992"
												stroke="#D1D5DC"
												strokeWidth="1.33333"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
											<path
												d="M12.6667 2.66675H3.33333C2.59695 2.66675 2 3.2637 2 4.00008V13.3334C2 14.0698 2.59695 14.6667 3.33333 14.6667H12.6667C13.403 14.6667 14 14.0698 14 13.3334V4.00008C14 3.2637 13.403 2.66675 12.6667 2.66675Z"
												stroke="#D1D5DC"
												strokeWidth="1.33333"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
											<path
												d="M2 6.66675H14"
												stroke="#D1D5DC"
												strokeWidth="1.33333"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
										</svg>
										{t("My Bookings")}
										{/* </Link> */}
									</DropdownItem>
									<DropdownItem
										onClick={() => props.history.push("/my-wallet")}>
										{/* <Link to="/"> */}
										<svg
											width="16"
											height="16"
											viewBox="0 0 16 16"
											fill="none"
											xmlns="http://www.w3.org/2000/svg">
											<path
												d="M12.6667 4.66667V2.66667C12.6667 2.48986 12.5964 2.32029 12.4714 2.19526C12.3464 2.07024 12.1768 2 12 2H3.33333C2.97971 2 2.64057 2.14048 2.39052 2.39052C2.14048 2.64057 2 2.97971 2 3.33333C2 3.68696 2.14048 4.02609 2.39052 4.27614C2.64057 4.52619 2.97971 4.66667 3.33333 4.66667H13.3333C13.5101 4.66667 13.6797 4.7369 13.8047 4.86193C13.9298 4.98695 14 5.15652 14 5.33333V8M14 8H12C11.6464 8 11.3072 8.14048 11.0572 8.39052C10.8071 8.64057 10.6667 8.97971 10.6667 9.33333C10.6667 9.68696 10.8071 10.0261 11.0572 10.2761C11.3072 10.5262 11.6464 10.6667 12 10.6667H14C14.1768 10.6667 14.3464 10.5964 14.4714 10.4714C14.5964 10.3464 14.6667 10.1768 14.6667 10V8.66667C14.6667 8.48986 14.5964 8.32029 14.4714 8.19526C14.3464 8.07024 14.1768 8 14 8Z"
												stroke="#D1D5DC"
												strokeWidth="1.33333"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
											<path
												d="M2 3.33337V12.6667C2 13.0203 2.14048 13.3595 2.39052 13.6095C2.64057 13.8596 2.97971 14 3.33333 14H13.3333C13.5101 14 13.6797 13.9298 13.8047 13.8048C13.9298 13.6798 14 13.5102 14 13.3334V10.6667"
												stroke="#D1D5DC"
												strokeWidth="1.33333"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
										</svg>

										{t("Wallet")}
										{/* </Link> */}
									</DropdownItem>
									<DropdownItem onClick={() => props.history.push("/profile")}>
										{/* <Link to="/"> */}
										<svg
											width="16"
											height="16"
											viewBox="0 0 16 16"
											fill="none"
											xmlns="http://www.w3.org/2000/svg">
											<path
												d="M12.6673 14V12.6667C12.6673 11.9594 12.3864 11.2811 11.8863 10.781C11.3862 10.281 10.7079 10 10.0007 10H6.00065C5.29341 10 4.61513 10.281 4.11503 10.781C3.61494 11.2811 3.33398 11.9594 3.33398 12.6667V14"
												stroke="#D1D5DC"
												strokeWidth="1.33333"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
											<path
												d="M8.00065 7.33333C9.47341 7.33333 10.6673 6.13943 10.6673 4.66667C10.6673 3.19391 9.47341 2 8.00065 2C6.52789 2 5.33398 3.19391 5.33398 4.66667C5.33398 6.13943 6.52789 7.33333 8.00065 7.33333Z"
												stroke="#D1D5DC"
												strokeWidth="1.33333"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
										</svg>

										{t("Profile")}
										{/* </Link> */}
									</DropdownItem>
									<DropdownItem divider />
									<DropdownItem
										className="logout"
										onClick={() => {
											Logout();
										}}>
										<svg
											width="16"
											height="16"
											viewBox="0 0 16 16"
											fill="none"
											xmlns="http://www.w3.org/2000/svg">
											<path
												d="M6 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H6"
												stroke="#FF6467"
												strokeWidth="1.33333"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
											<path
												d="M10.666 11.3333L13.9993 7.99996L10.666 4.66663"
												stroke="#FF6467"
												strokeWidth="1.33333"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
											<path
												d="M14 8H6"
												stroke="#FF6467"
												strokeWidth="1.33333"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
										</svg>

										{t("logout")}
									</DropdownItem>
								</DropdownMenu>
							</UncontrolledDropdown>
						) : (
							<div>
								<Link to={"/login"} className="login-button custom-button">
									<span className="login-text">{t("login")}</span>
									<span className="login-icon">
										<svg
											width="22"
											height="22"
											viewBox="0 0 24 24"
											fill="none"
											xmlns="http://www.w3.org/2000/svg">
											<path
												d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
												stroke="white"
												strokeWidth="2"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
												stroke="white"
												strokeWidth="2"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
										</svg>
									</span>
								</Link>
							</div>
						)}

						<NavbarToggler
							className="border-0 p-0 navbar-toggler-white"
							aria-label="Open menu"
							onClick={() => setisOpenMenu(true)}
						/>
					</div>
				</Navbar>
				<Offcanvas
					style={{
						background: "var(--body-bg)",
					}}
					show={isOpenMenu}
					onHide={() => setisOpenMenu(false)}>
					<Offcanvas.Header>
						<img
							src={logo}
							alt="VR Premium Studio"
							width={45}
							height={45}
							className="img-fluid img-new-logo"
						/>
						<button
							className="close-navbar"
							aria-label="Close menu"
							onClick={() => setisOpenMenu(false)}>
							<svg
								width="20"
								height="20"
								viewBox="0 0 24 24"
								fill="none"
								stroke="currentColor"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round">
								<line x1="18" y1="6" x2="6" y2="18" />
								<line x1="6" y1="6" x2="18" y2="18" />
							</svg>
						</button>
					</Offcanvas.Header>
					<Offcanvas.Body className="navbarDashboard">
						<Nav className="me-auto" navbar>
							<NavItem>
								<Link to={`/`} className="nav-link mobile-nav-link">
									{t("Home")}
								</Link>
							</NavItem>
							<NavItem>
								<Link to={`/games`} className="nav-link mobile-nav-link">
									{t("games")}
								</Link>
							</NavItem>
							<NavItem>
								<Link to={`/about-us`} className="nav-link mobile-nav-link">
									{t("About Us")}
								</Link>
							</NavItem>
							<NavItem>
								<Link to={`/support`} className="nav-link mobile-nav-link">
									{t("support")}
								</Link>
							</NavItem>
						</Nav>
					</Offcanvas.Body>
				</Offcanvas>
			</Container>
		</nav>
	);
};

export default withRouter(withTranslation()(Header));
